import sortBy from 'lodash/sortBy';
import type { MonitorDelivery } from '../../types';
import { DeliveryMonitorCard } from '../delivery-card/delivery-card';
import styles from './deliveries-grid.module.scss';

interface DeliveriesGridProps {
  deliveries: MonitorDelivery[];
  selectedDeliveryId?: string;
  onOpenDetail: (deliveryId: string) => void;
}

export function DeliveriesGrid({
  deliveries,
  selectedDeliveryId,
  onOpenDetail,
}: DeliveriesGridProps) {
  const sortedDeliveries = sortBy(deliveries, delivery =>
    new Date(delivery.createdAt).getTime(),
  );

  return (
    <div className={styles.grid}>
      {sortedDeliveries.map(delivery => (
        <DeliveryMonitorCard
          key={delivery._id}
          delivery={delivery}
          isSelected={delivery._id === selectedDeliveryId}
          onOpenDetail={onOpenDetail}
        />
      ))}
    </div>
  );
}
